import { render, staticRenderFns } from "./ServicesDetails.vue?vue&type=template&id=186bee5e&"
import script from "./ServicesDetails.vue?vue&type=script&lang=js&"
export * from "./ServicesDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServicesDetails.vue?vue&type=style&index=0&id=186bee5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports